import { APIClient } from "./api_helper";

import * as url from "./url_helper";
import { DEFAULT_PAGE_SIZE, GAME_TYPES, CACHE_KEYS } from "../common/constants";

const api = new APIClient();

// Authentication APIs
export const chatLogin = (data) => api.create(url.LOGIN, data);
export const forgotPassword = data => api.create(url.PASSWORD_FORGET, data);
export const ResetPassword = data => api.create(url.RESET_PASSWORD, data);

// Admin APIs
export const adminLogin = (data) => api.create(url.ADMIN_LOGIN, data);
export const getAdminProfile = () => api.get(url.ADMIN_PROFILE);
export const updateAdminProfile = (data) => api.put(url.ADMIN_UPDATE, data);
export const adminForgotPassword = (data) => api.create(url.ADMIN_FORGOT_PASSWORD, data);
export const adminResetPassword = (data) => api.create(url.ADMIN_RESET_PASSWORD, data);

// Profile APIs
export const editUser = (data) => api.put(`${url.EDIT_USER}`, data);
export const fetchProfile = (data) => api.get(url.FETCH_PROFILE, data);

// Dashboard APIs
export const dashboardCount = (params) => api.get(url.EARNINGS_URL, params);

// File upload API
export const uploadFile = (data) =>
  api.create("api/upload", data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });

// Settings APIs (Legacy/Generic maps to LT)
export const getSettings = () => api.get(url.LT_SETTINGS_URL);
export const updateSettings = (data) => api.put(url.LT_SETTINGS_URL, data);
export const getMultiplier = () => api.get(url.SETTINGS_MULTIPLIER_URL);
export const setManualWinner = (data) => api.create(url.LT_MANUAL_WINNER_URL, data);

// --- Lucky Target (Game 1) Specific ---
export const getSettingsLT = () => api.get(url.LT_SETTINGS_URL);
export const updateSettingsLT = (data) => api.put(url.LT_SETTINGS_URL, data);
export const setManualWinnerLT = (data) => api.create(url.LT_MANUAL_WINNER_URL, data);

// --- Lucky Target 1 (Game 1) Specific ---
export const getSettingsLT1 = () => api.get(url.LT1_SETTINGS_URL);
export const updateSettingsLT1 = (data) => api.put(url.LT1_SETTINGS_URL, data);
export const setManualWinnerLT1 = (data) => api.create(url.LT1_MANUAL_WINNER_URL, data);

// --- Lucky Target 3 (Game 5) Specific ---
export const getSettingsLT3 = () => api.get(url.LT3_SETTINGS_URL);
export const updateSettingsLT3 = (data) => api.put(url.LT3_SETTINGS_URL, data);
export const setManualWinnerLT3 = (data) => api.create(url.LT3_MANUAL_WINNER_URL, data);

// --- American Roulette (Game 3) Specific ---
export const getSettingsRO = () => api.get(url.RO_SETTINGS_URL);
export const updateSettingsRO = (data) => api.put(url.RO_SETTINGS_URL, data);
export const setManualWinnerRO = (data) => api.create(url.RO_MANUAL_WINNER_URL, data);

// --- Sorat (Game 4) Specific ---
export const getSettingsSO = (platform = "web") => api.get(url.SO_SETTINGS_URL, { platform });
export const updateSettingsSO = (data) => api.put(url.SO_SETTINGS_URL, { platform: "web", ...data });
export const setManualWinnerSO = (data) => api.create(url.SO_MANUAL_WINNER_URL, { platform: "web", ...data });

export const getAllUsers = (params) => api.get(`${url.USERS_URL}/all`, params);
export const deleteUser = (userId) => api.delete(`${url.USERS_URL}/${userId}`);
export const getUserHistory = (userId, params = {}) => {
  const { gameType, ...queryParams } = params;
  // Normalize gameType values coming from routes/UI
  const normalizedGameType =
    gameType === GAME_TYPES.LT1 || gameType === CACHE_KEYS.LT1 ? GAME_TYPES.LT1 :
    gameType === GAME_TYPES.LT3 || gameType === CACHE_KEYS.LT3 ? GAME_TYPES.LT3 : GAME_TYPES.LT;
  const baseUrl =
    normalizedGameType === GAME_TYPES.LT3 ? url.USER_HISTORY_LT3_URL :
    normalizedGameType === GAME_TYPES.LT1 ? url.USER_HISTORY_LT1_URL : url.USER_HISTORY_URL;

  return api.get(`${baseUrl}/${userId}`, {
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
    type: 'all',
    ...queryParams
  });
};

// Dedicated endpoints (no conditional) for user history
export const getUserHistoryLT = (userId, params = {}) =>
  api.get(`${url.USER_HISTORY_URL}/${userId}`, {
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
    type: "all",
    ...params,
  });

export const getUserHistoryLT1 = (userId, params = {}) =>
  api.get(`${url.USER_HISTORY_LT1_URL}/${userId}`, {
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
    type: "all",
    ...params,
  });

export const getUserHistoryRO = (userId, params = {}) =>
  api.get(`${url.USER_HISTORY_RO_URL}/${userId}`, {
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
    type: "all",
    gameType: GAME_TYPES.RO,
    ...params,
  });

export const getUserHistorySO = (userId, params = {}) =>
  api.get(`${url.USER_HISTORY_SO_URL}/${userId}`, {
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
    type: "all",
    gameType: "so",
    ...params,
  });

export const getUserHistoryLT3 = (userId, params = {}) =>
  api.get(`${url.USER_HISTORY_LT3_URL}/${userId}`, {
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
    type: "all",
    gameType: GAME_TYPES.LT3,
    ...params,
  });



export const getJokerSettings = () => api.get(url.JOKER_SETTINGS_URL);
export const updateJokerSettings = (data) => api.put(url.JOKER_SETTINGS_URL, data);

// Create new joker (POST)
export const createJoker = (data) => api.create(url.JOKER_SETTINGS_URL, data);

// Update existing joker (PUT)
export const updateJoker = (jokerId, data) => api.put(`${url.JOKER_SETTINGS_URL}/${jokerId}`, data);

export const getJokerSession = (params) => api.get(url.GET_JOKER_SESSION, params);
export const getJokerSessionById = (jokerId) => api.get(`${url.JOKER_SETTINGS_URL}/${jokerId}`);
export const getJokerPnL = (params) => api.get(url.GET_JOKER_PNL, params);
export const getGeneralPnL = (params) => api.get(url.GET_GENERAL_PNL, params);

// Withdrawal APIs
export const getWithdrawalUsers = (params) => api.get(url.WITHDRAWAL_USERS_URL, params);
export const addWithdrawalCoins = (data) => api.create(url.WITHDRAWAL_ADD_COINS_URL, data);
export const removeWithdrawalCoins = (data) => api.create(url.WITHDRAWAL_REMOVE_COINS_URL, data);
export const getWithdrawalHistory = (userId, params = {}) => api.get(`${url.WITHDRAWAL_HISTORY_URL}/${userId}`, params);
export const getUserTransactions = (userId, params = {}) => api.get(`${url.USER_TRANSACTIONS_URL}/${userId}`, params);
export const getUserGameHistory = (userId, params = {}) => api.get(`${url.USER_GAME_HISTORY_URL}/${userId}`, params);
export const getUserBalanceHistory = (userId, params = {}) => api.get(`${url.USER_BALANCE_HISTORY_URL}/${userId}`, params);

// App Settings APIs
export const fetchAppSettings = () => api.get(url.APP_SETTINGS_URL);
export const updateAppSettings = (data) => api.create(url.APP_SETTINGS_URL, data);
export const fetchGameplayParams = (params) => api.get(url.GAMEPLAY_PARAMS_URL, params);
export const updateGameplayParams = (data) => api.create(url.GAMEPLAY_PARAMS_URL, data);
export const fetchOperatorGameplayParams = (params) => api.get(url.OPERATOR_GAMEPLAY_PARAMS_URL, params);
export const updateOperatorGameplayParams = (data) => api.create(url.OPERATOR_GAMEPLAY_PARAMS_URL, data);

// Operator Management APIs
export const getOperators = (params) => api.get(url.OPERATORS_URL, params);
export const createOperator = (data) => api.create(url.OPERATORS_URL, data);
export const updateOperator = (id, data) => api.put(`${url.OPERATORS_URL}/${id}`, data);
export const getOperatorDropdown = () => api.get(url.OPERATOR_DROPDOWN_URL);
export const getOperatorUsers = (operatorId) => api.get(`${url.OPERATORS_URL}/${operatorId}/users`);
export const getOperatorUsersByNumber = (operatorNumber) => api.get(`${url.OPERATORS_URL}/number/${operatorNumber}/users`);
export const getOperatorGames = (operatorId) => api.get(`${url.OPERATOR_GAMES_STATS_URL}/${operatorId}/games`);

// User Password Update (Admin)
export const updateUserPassword = (userId, data) => api.put(`${url.USER_UPDATE_PASSWORD_URL}/${userId}/update-password`, data);
export const updateUserData = (userId, data) => api.put(`${url.USER_UPDATE_PASSWORD_URL}/${userId}`, data);
export const updateUserStatus = (userId, data) => api.put(`${url.USER_UPDATE_PASSWORD_URL}/${userId}`, data);
export const createUser = (data) => api.create(url.CREATE_USER_BY_OPERATOR_URL, data);
export const getTransactions = (params) => api.get(url.TRANSACTIONS_URL, params);
export const exportTransactions = (params) => api.get(url.TRANSACTIONS_EXPORT_URL, { ...params, export: 'excel' });
export const getDayReport = (params) => api.get(url.DAY_REPORT_URL, params);